export class VoucherModel{
    _id?: any;
    uuid: string
    revision: string;
    vrsn: string;
    status: string;
    voucher_id: string;
    promotion_start_time: number;
    promotion_end_time: number;
    voucher_name: string;
    voucher_discount_type: string;
    create_date: Date;
    update_date: Date;
    channel_id: string;
    channel: string;
    criteria: string;
    discount: string;
    display_area: string;
    limit: string;
    issued: string;
    voucher_type: string;
    apply_to: string;   
    voucher_code: string;   
}